import apiClient from './axiosConfig';
import { getAttribution } from './attribution';

const SESSION_KEY = 'adwary_acquisition_session';

function getSessionId() {
  try {
    let sessionId = sessionStorage.getItem(SESSION_KEY);
    if (!sessionId) {
      sessionId = typeof window.crypto?.randomUUID === 'function'
        ? window.crypto.randomUUID()
        : `${Date.now()}-${Math.random().toString(36).slice(2)}`;
      sessionStorage.setItem(SESSION_KEY, sessionId);
    }
    return sessionId;
  } catch {
    return '';
  }
}

export async function trackAcquisitionEvent(event, route = window.location.pathname) {
  try {
    await apiClient.post('/acquisition-events', {
      event,
      route,
      session_id: getSessionId(),
      ...getAttribution(),
    });
  } catch {
    // Measurement must never interrupt the acquisition flow.
  }
}
